import {delay} from 'rxjs/operators';
import {IAreaJewellers} from 'src/app/shared/interfaces/icity-jewellers';
import {Injectable} from '@angular/core';
import {IPopularJewellers} from 'src/app/shared/interfaces/ipopular-jewellers';
import {IStore} from 'src/app/shared/interfaces/istore';
import {of} from 'rxjs';
import {ApiService} from "../../core/services/api.service";
import {ApiRequestEnum} from "../../core/enums/api-request.enum";
import {CriteriaModel} from "../../shared/interfaces/CriteriaModel";

@Injectable({
	providedIn: 'root',
})
export class RootService {
	constructor(
		private apiService: ApiService,
	) {
	}

	getPopularJewellers(param: any) {
		return this.apiService.get(ApiRequestEnum.BRAND_POPULAR, param);
	}

	getBanners(params: Object) {
		return this.apiService.post(
			ApiRequestEnum.BANNER,
			params
		);
	}

	getMetalRates(param: CriteriaModel) {
		return this.apiService.post(ApiRequestEnum.METAL_RATES, param);
	}

	subscribeNewsletter(param: Object) {
		return this.apiService.post(ApiRequestEnum.NEWSLETTER_SUBSCRIBE, param);
	}
}
